import { useTranslation } from 'react-i18next';

import { HOLIDAYS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditHoliday from './components/CreateEditHoliday';

import useColumnDefinitions from './hooks/useColumnDefinitions';
import { useGetHolidays } from '../../../../../queries';

const Holidays = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetHolidays();
  const columnDefinitions = useColumnDefinitions();

  const { mutate: handleDeleteClick } = useDeleteById(HOLIDAYS, ['holidays']);

  return (
    <TableCRUDLayout
      FormComponent={CreateEditHoliday}
      rows={data}
      loading={isFetching}
      columns={columnDefinitions}
      confirmationTitle={t('holidays.deleteHolidayDialog.title')}
      confirmationBody={t('holidays.deleteHolidayDialog.body')}
      getRowId={(row) => row.holidayId}
      onDeleteClick={(id) => handleDeleteClick(id)}
    />
  );
};

export default Holidays;
